(() => {
  const popup = document.querySelector('[data-be-email-popup]');
  if (!popup || typeof popup.showModal !== 'function') return;
  const keys = { start: 'be_email_start', seen: 'be_email_seen', dismissed: 'be_email_dismissed', subscribed: 'be_email_subscribed' };
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const save = (storage, key, value) => { try { window[storage].setItem(key, String(value)); } catch {} };
  const success = popup.querySelector('[data-be-email-success]');
  const error = popup.querySelector('[data-be-email-error]');
  let timer;
  const show = () => {
    if (document.hidden || document.querySelector('dialog[open]')) return false;
    popup.showModal();
    save('sessionStorage', keys.seen, '1');
    return true;
  };
  const dismiss = () => {
    save('localStorage', keys.dismissed, Date.now());
    popup.close();
  };
  popup.querySelectorAll('[data-be-email-close]').forEach(button => button.addEventListener('click', dismiss));
  popup.addEventListener('cancel', () => save('localStorage', keys.dismissed, Date.now()));
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  if (success) {
    save('localStorage', keys.subscribed, '1');
    if (!show()) document.addEventListener('visibilitychange', () => { if (!popup.open) show(); }, { once: true });
    return;
  }
  if (error) { show(); return; }
  if (popup.dataset.beEmailSubscriber === 'true') return;
  const dismissed = Number(read('localStorage', keys.dismissed) || 0);
  if (read('localStorage', keys.subscribed) || read('sessionStorage', keys.seen) || Date.now() - dismissed < 7 * 24 * 60 * 60 * 1000) return;
  const storedStart = Number(read('sessionStorage', keys.start) || 0);
  const start = storedStart > 0 && storedStart <= Date.now() ? storedStart : Date.now();
  save('sessionStorage', keys.start, start);
  const attempt = () => {
    if (Date.now() - start < 30000) {
      timer = setTimeout(attempt, Math.max(100, 30000 - (Date.now() - start)));
      return;
    }
    if (!show()) timer = setTimeout(attempt, 1000);
  };
  timer = setTimeout(attempt, Math.max(0, 30000 - (Date.now() - start)));
  window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
})();